export default "__VITE_ASSET__qbo2CueS__"